import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import filters from '@/filters.js'
import 'nprogress/nprogress.css'
import VueMask from '@devindex/vue-mask'
import { createHead } from '@vueuse/head'

import { GDialog, plugin as dialogPlugin } from 'gitart-vue-dialog'
import 'gitart-vue-dialog/dist/style.css'

const app = createApp(App)
const head = createHead()

app
  .use(router)
  .use(store)
  .use(dialogPlugin)
  .use(VueMask)
  .use(head)
  .component('GDialog', GDialog)
  .mount('#app')

app.config.globalProperties.$filters = filters
